import { SceneViewerData } from '../../../Content';

export interface Props {
  content: SceneViewerData;
}

export const SceneViewerContent: React.FC<Props> = ({ content }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <iframe
        title="webgl-viewer"
        src={`./?p=${content.sceneID}`}
        style={{
          width: '100%',
          height: '100%',
        }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};
